import React, { useState , useEffect} from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { BrowserRouter,useNavigate } from "react-router-dom";
import "./i18n";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { SocketContext, socket } from "./utils/socketio";
import { ToastContainer } from "react-toastify";
import { SocialLogin } from "./api/user";
import Loader from "./components/Loader";

const RootComponent = () => {
  const [loading, setLoading] = useState(false);

  // Define a global function that mobile app developers can call from the console
  window.sendDataToReactApp = function (data) {
    console.log("Data received from mobile app:", data);
    const jsonData = data;
    // Extract and handle specific keys
    const deviceName = jsonData["Device-Name"];
    const deviceType = jsonData["Device-Type"];
    const fcmToken = jsonData["FCM-Token"];
    const deviceToken = jsonData["Device-Token"];

    localStorage.setItem("FCM", fcmToken);
    localStorage.setItem("DeviceName", deviceName);
    localStorage.setItem("DeviceType", deviceType);
    localStorage.setItem("DeviceToken", deviceToken);
  };

  // Define the function to handle Google data

  window.sendImage = function (data) {
    console.log("Data received from mobile app:", data);
    const myCustomEvent = new CustomEvent("myCustomProfileEvent", {
      detail: {
        image: data,
      },
    });
    window.dispatchEvent(myCustomEvent);
    localStorage.setItem("image", data);
  };
  window.sendImagePost = function (...data) {
    console.log("Data received from mobile app:", data);
    const myCustomEvent = new CustomEvent("myCustomPostEvent", {
      detail: {
        imagePost: JSON.stringify(data),
      },
    });
    window.dispatchEvent(myCustomEvent);
    localStorage.setItem("imagePost", data);
  };

    window.sendImageGame = function (...data) {
    console.log("Data received from mobile for game:", data);
    const myCustomEvent = new CustomEvent("myCustomPostEvent", {
      detail: {
        imageGame: JSON.stringify(data),
      },
    });
    window.dispatchEvent(myCustomEvent);
    localStorage.setItem("imageGame", data);
  };


    window.showAlertOnAppSide = function (...data) {
    console.log("Data received from mobile for alert:", data);
    alert(data);
  };

    window.dismissModal = function (...data) {
      console.log("Data received from mobile for dismiss:",data);
      const myCustomEvent = new CustomEvent("myDismissModalEvent");
      window.dispatchEvent(myCustomEvent);
    };


// const DeepLinkHandler = () => {
//   const navigate = useNavigate(); // Use the navigate function from React Router

//   useEffect(() => {
//     // Function to handle the deep link
//     const handleDeepLink = (event) => {
//       const deepLink = event.detail; // The deep link URL passed in the event
//       if (deepLink) {
//         const route = new URL(deepLink).pathname; // Extract the pathname from the URL
//         navigate(route); // Navigate to the extracted route
//       } else {
//         console.error("No deep link provided!");
//       }
//     };

//     // Listen for the custom deepLinkEvent
//     window.addEventListener("deepLinkEvent", handleDeepLink);

//     // Cleanup the event listener on unmount
//     return () => {
//       window.removeEventListener("deepLinkEvent", handleDeepLink);
//     };
//   }, [navigate]);

//   return null; // This component does not render anything, just handles side effects
// };

const DeepLinkHandler = () => {
  const navigate = useNavigate(); // Get the navigate function

  useEffect(() => {
    // Function to handle the deep link and navigate
    const handleDeepLink = (link) => {
      console.log('deep link url is',link);
      if (link) {
        const route = new URL(link).pathname; // Extract the pathname from the deep link
        navigate(route); // Navigate to the route
      } else {
        console.error("No deep link provided!");
      }
    };

    // Expose the handleDeepLink function globally to be called from the mobile app
    window.handleDeepLink = handleDeepLink;

    // Cleanup when the component is unmounted
    return () => {
      window.handleDeepLink = null; // Remove the function
    };
  }, [navigate]);

  return null; // This component does not render anything
};



  window.sendImageChat = function (...data) {
    console.log("Data received from mobile app:", data);
    const myCustomEvent = new CustomEvent("myCustomChatEvent", {
      detail: {
        imageChat: data,
      },
    });
    window.dispatchEvent(myCustomEvent);
    localStorage.setItem("imageChat", data);
  };
  window.sendEventForGoogleLogout = function (...data) {};
  return (
    <SocketContext.Provider value={socket}>
      <BrowserRouter>
      <DeepLinkHandler />
        <GoogleOAuthProvider clientId="44398670211-s1kk88od6okj1io32dj0bptoahqh46pn.apps.googleusercontent.com">
          <App />
          <ToastContainer hideProgressBar={true} />
        </GoogleOAuthProvider>
      </BrowserRouter>
    </SocketContext.Provider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootComponent />);
